import { render, staticRenderFns } from "./bloodChild.vue?vue&type=template&id=64ff4276&scoped=true&"
import script from "./bloodChild.vue?vue&type=script&lang=js&"
export * from "./bloodChild.vue?vue&type=script&lang=js&"
import style0 from "./bloodChild.vue?vue&type=style&index=0&id=64ff4276&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ff4276",
  null
  
)

export default component.exports